import { Router } from '@angular/router';
import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-manutencao-page',
  templateUrl: './manutencao-page.component.html',
  styleUrls: ['./manutencao-page.component.scss'],
})
export class ManutencaoPageComponent {
  constructor(public router: Router) {}
  goToDashboard() {
    this.router.navigate([`/`]);
  }
}
